// extracted by mini-css-extract-plugin
module.exports = {"tancarFlotant":"videoBase_tancarFlotant__leI9d","show":"videoBase_show__kHWCE","botoTancar":"videoBase_botoTancar__t1M6X"};